import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../../../pages/order/models/orderModel';
import RestoreActionOrder from '../../../pages/order/actions/restoreAction';

export default class RestoreAction extends AttendeeAction {
    static NAME = 'restore';
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    //only reserved and payed orders and attendee deleted and without seating
    static condition(attendee) {
        return ['valid', 'reservation'].includes(attendee.order.status) && attendee.removed && !attendee.booking;
    }

    //deleted and without seating
    static is_attendee_valid({ attendee, order }) {
        return attendee.removed && !attendee.booking;
    }

    //available if event no closed, no over, no deleted and without seating
    static is_available({ feature_flags, event }) {
        return !event.isRealSeating() && !event.isFakeSeating() && !event.use_sessions && !['over', 'closed'].includes(event.status) && !event.removed;
    }

    run({ orders = null, attendees = null }) {
        if (orders) {
            //only reserved and payed with with at least one deleted participant
            const to_restore = orders.filter(o => RestoreActionOrder.condition(o));
            return Order.perform_action(RestoreActionOrder.NAME, to_restore, { organization: this.organization, event: this.event });
        }

        return Attendee.perform_action(this.constructor.NAME, attendees || this.filtered_items, { organization: this.organization, event: this.event }, this.isAsync(attendees));
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
